import router from '@/router';

export const navigateTo = (to) => {
  if (!to) return;
  const currentPath = router.app?.$route.path;
  if (currentPath === to) return;
  return router.push(to);
};
